import { useEffect } from 'react';

function useCheckControlledInputs() {
  useEffect(() => {
    const inputs = document.querySelectorAll('input, select, textarea');

    inputs.forEach(input => {
      const hasValue = input.hasAttribute('value');
      const hasOnChange = input.getAttribute('onchange') !== null;
      const isDisabled = input.disabled;
      const isReadOnly = input.readOnly;
      const isControlled = hasValue && !hasOnChange && !isDisabled && !isReadOnly;

      if (isControlled) {
        console.warn(`⚠️ Campo com 'value' mas sem 'onChange':`, input);
      }
    });
  }, []);
}
export default useCheckControlledInputs;
